import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import PageWrapper from 'src/components/PageWrapper/PageWrapper';
import LandingPage from 'src/pages/LandingPage/LandingPage';
import { useZoneDataContext } from 'src/provider/ZoneDataProvider';

export const Route = createFileRoute('/decisions/$zone')({
  component: RouteComponent
});

function RouteComponent() {
  const { zone } = Route.useParams();
  const { setSelectedZone, loading } = useZoneDataContext();

  useEffect(() => {
    if (!loading) {
      setSelectedZone(zone);
    }
  }, [zone, loading, setSelectedZone]);

  return (
    <PageWrapper title="Water markets decisions" description="Trades, rights and decisions in the Murray-Darling Basin">
      <LandingPage />
    </PageWrapper>
  );
}
